/* eslint-disable */
import { Avatar, Box, Grid, Paper, Switch, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import { toast } from 'react-toastify';

import Key from '../../../clientVariables.json';
import { useResponsiveStyles } from '../../../utils/responsiveStyles';
import palette from '../../../theme/palette';
import Contract from '../Contract';
import Summary from './Summary';
import InvoicesByCustomer from './InvoicesByCustomer';
// import ActivitiesByCustomer from './ActivitiesByCustomer';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ContractDetails = () => {
  const currentUser = useSelector((state) => state.UserReducer.user);
  const selectedContract = useSelector((state) => state.contractsManagement.selectedContract);
  const [value, setValue] = React.useState(0);
  const styles = useResponsiveStyles();
  const [active, setActive] = useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getContractDetails = async (customerID) => {
    try {
      const response = await axios.get(`${Key.domain}/payment/contract/${customerID}`);
      if (customerID) {
      }
    } catch (error) {
      console.error(error);
    }
  };

  const text1Styles = {
    m: 0,
    fontSize: styles.fontSize12,
    fontWeight: 500,
    color: palette.grey[600],
  };

  return (
    <Grid container spacing={0} sx={{ border: `1px solid ${palette.grey[300]}` }}>
      <Grid item xs={12}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            minHeight: '32px',
            '& .MuiTab-root': {
              fontSize: styles.fontSize12,
              minHeight: '32px', // Ensure individual tabs also decrease in height
              padding: '6px 12px', // Adjust padding
              minWidth: '60px', // Decrease tab width
            },
            '& .Mui-selected': {
              color: '#1976d2 !important',
              // backgroundColor: '#e3f2fd',
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#1976d2',
            },
          }}
        >
          <Tab label="Summary" {...a11yProps(0)} />
          <Tab label="Renewals" {...a11yProps(1)} />
          <Tab label="Administration" {...a11yProps(2)} />
          <Tab label="Transactions" {...a11yProps(3)} />
        </Tabs>
        <CustomTabPanel value={value} index={0}>
          <Summary />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          Renewals
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          Administration
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          {/* <InvoicesByCustomer /> */}
          {/* <ActivitiesByCustomer /> */}
        </CustomTabPanel>
      </Grid>
    </Grid>
  );
};

export default ContractDetails;
